import React from "react";
import type { FC } from "react";

import { Counter } from "../../../Counter/Counter";

import type { ExcludeCustomView, PickOfUnion } from "../../../../types/react";
import type { CounterProps } from "../../../Counter";

const PICTURE_COUNTER_TEST_ID = "picture-counter-test-id";

interface IPictureCounterMain extends Pick<CounterProps, "size"> {}

type PictureCounter = PickOfUnion<CounterProps, "quantity">;

export const PictureCounter: FC<PictureCounter> = (props) => {
    const { ...restProps } = props as PictureCounter &
        IPictureCounterMain &
        ExcludeCustomView<CounterProps>;

    return (
        <Counter
            {...restProps}
            view="primary"
            stroke
            data-tsid={PICTURE_COUNTER_TEST_ID}
        />
    );
};

PictureCounter.displayName = "Picture.Counter";

export default PictureCounter;
